<template>
  <v-container
    class="auth"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md5
        lg4
        mt-10
      >
        <center>
          <v-img
            :src="logo"
            :lazy-src="logo"
            :max-width="logoMaxWidth"
            contain
          />
        </center>
        <v-card>
          <v-form
            v-if="!submitted"
            @submit.prevent="NewPassword"
          >
            <v-layout
              newpassword
              wrap
            >
              <v-flex
                xs12
                md12
              >
                <h2>{{ $t('newpassword.newPassword') }}</h2>
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  id="password"
                  v-model.trim="form.password"
                  :error-messages="PasswordErrors"
                  name="password"
                  :label="$t('newpassword.password')+'*'"
                  autocomplete="new-password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  required
                  @click:append="showPassword = !showPassword"
                  @input="$v.form.password.$touch()"
                  @blur="$v.form.password.$touch()"
                />
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  id="password2"
                  v-model.trim="form.password2"
                  :error-messages="PasswordErrors2"
                  name="password2"
                  :label="$t('newpassword.confirm')+'*'"
                  autocomplete="new-password"
                  :type="showPassword2 ? 'text' : 'password'"
                  :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                  required
                  @click:append="showPassword2 = !showPassword2"
                  @input="$v.form.password2.$touch()"
                  @blur="$v.form.password2.$touch()"
                />
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-btn
                  class="primary"
                  block
                  x-large
                  :disabled="loading"
                  :loading="loading"
                  @click="NewPassword"
                >
                  {{ $t('newpassword.confirmReset') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout v-if="submitted">
            <v-flex
              verification
              xs12
              md12
            >
              <h2>{{ $t('newpassword.success1') }}</h2>
              <h5>{{ $t('newpassword.success2') }}</h5>
            </v-flex>
          </v-layout> 
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'

const good_password = value => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(value)

export default {
  name: 'NewPassword',
  mixins: [validationMixin],
  data() {
    return  {
      logoLight: this.$ls.get('config').logo_light_theme,
      logoDark: this.$ls.get('config').logo_dark_theme,
      loading: false,
      showPassword: false,
      showPassword2: false,
      error: false,
      submitted: false,
      form: {
          password: '',
          password2: ''
      }
    }
  },
  validations () {
    return {
      form: this.rules
    }
  },
  computed: {
    logo() {
      return this.$vuetify.theme.dark ? this.logoDark : this.logoLight
    },
    logoMaxWidth() {
      const config = this.$ls.get('config')
      if (config && config.public_config && config.public_config.app_auth_logo_max_width) {
        return config.public_config.app_auth_logo_max_width
      }
      return null
    },
    rules () {
      var form = {
        password: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(255),
            good_password
        },
        password2: {
            sameAsPassword: sameAs('password')
        },
      }
      return form
    },
    PasswordErrors () {
      const errors = []
      if (!this.$v.form.password.$dirty) return errors
      !this.$v.form.password.required &&
        errors.push(this.$t('newpassword.reqPassword'))
      !this.$v.form.password.maxLength &&
        errors.push(this.$t('register.maxPassword'))  
      !this.$v.form.password.good_password &&
        errors.push(this.$t('register.mustPassword'))  
      return errors
    },
    PasswordErrors2 () {
      const errors = []
      if (!this.$v.form.password2.$dirty) return errors
      !this.$v.form.password2.sameAsPassword &&
        errors.push(this.$t('newpassword.samePassword'))
      return errors
    },
  },
  methods: {
    NewPassword() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true;  
        this.$apollo.mutate({
            mutation: require('@/graphql/mutations/NewPassword.gql'),
            variables: {
                email: this.$route.query.email,
                token: this.$route.params.id,
                password: this.form.password
            }       
        }).then(data => {
            this.loading = false;
            if (data.data.updateForgottenPassword.status == 'PASSWORD_NOT_UPDATED') {
              this.error = data.data.updateForgottenPassword.message;
              this.$store.commit('app/setNotifier', this.error);
            } else {
              this.submitted = true;
              setTimeout(() => {
                this.$router.push('login')
              }, 3000)
            }
        }).catch(error => {
            this.errorHandler(error)
            this.loading = false;  
        })
      }
    },
  }
}
</script>

<style lang="scss">

</style>
